// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"SC3BE6wv","secondary":"HAE5hZWF","styledButton":"lp6JP5lR","prev":"dMlCi1hB","next":"SAv8Rmiu","tabButton":"rA_kRK15","active":"HYMSKUVf"};